import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {PatientSphereAction, SPHERE} from '../../models/patient-sphere';
import {IPatient, PatientState} from '../../models/patient';
import {GenderEnum} from '../../models/user';
import {MiniSphereNamespace} from '../../namespaces/mini-sphere.namespace';
import {PhysicalActivityLevelEnum, RecordTypeEnum} from '../../enums/record';
import {ILevelActivityValues} from '../important-info-patient/important-info-patient.component';
import {AuthState, IUser} from '../../models/auth';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {SphereModeEnum} from '../../enums/sphere/sphere-mode.enum';
import {Select, Store} from '@ngxs/store';
import {ServiceAction, ServiceState} from '../../models/service';
import {firstValueFrom, Observable} from 'rxjs';
import {SkeletonEnum} from '../../enums/skeleton';
import {SkeletonService} from '../../services/skeleton/skeleton.service';

@Component({
  selector: 'app-mini-sphere',
  templateUrl: './mini-sphere.component.html',
  styleUrls: ['./mini-sphere.component.scss']
})
export class MiniSphereComponent implements OnInit, OnChanges {
  @Select(ServiceState.getServicePatientRecordMode) recordMode$: Observable<SphereModeEnum>;
  @Select(AuthState.getIsExpert) isExpert$: Observable<boolean>;

  @Input() patientRelevantDataMiniSphere: MiniSphereNamespace.IMiniSphere;
  @Input() patient: IPatient;
  @Input() levelActivity: ILevelActivityValues;
  @Input() options: {  };
  @Input() userLogged: IUser;
  @Input() sedentaryLevel: any;
  @Input() loaded: boolean;
  @Output() redirectTo: EventEmitter<RecordTypeEnum> = new EventEmitter<RecordTypeEnum>();

  genderEnum = GenderEnum;
  viewInformation: boolean;
  physicalActivityLevelEnum = PhysicalActivityLevelEnum;
  recordTypeEnum = RecordTypeEnum;
  biochemical: SPHERE.ISphereBiochemical[] = [];
  sepherMode = SphereModeEnum;
  skeletonTemplate: any[] = [];

  constructor(
    private utilitiesService: UtilitiesService,
    private store: Store,
    private skeletonService: SkeletonService,
  ) {}

  protected readonly GenderEnum = GenderEnum;
  protected readonly PhysicalActivityLevelEnum = PhysicalActivityLevelEnum;
  protected readonly RecordTypeEnum = RecordTypeEnum;

  ngOnInit(): void {
    this.skeletonTemplate = this.skeletonService.build(SkeletonEnum.SPHERE);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.patientRelevantDataMiniSphere && this.patientRelevantDataMiniSphere !== void 0) {
      this.biochemical = this.utilitiesService.getBiochemicalArray(this.patientRelevantDataMiniSphere.biochemical);
    }
  }
  async onRedirectTo(record: RecordTypeEnum): Promise<void> {
    this.redirectTo.emit(record);
  }

  /**
   * This method closes the sphere and prevents propagation
   * @param event event of element HTML
   */
  async onCloseSphere(event: any): Promise<void> {
    event.stopPropagation();
    await firstValueFrom(this.store.dispatch(new PatientSphereAction.OpenSphere(false)));
  }


  async onSwitchSphere(): Promise<void> {
    this.loaded = false;
    const modeSphere = await firstValueFrom(this.recordMode$);

    await firstValueFrom(
      this.store.dispatch(
        new ServiceAction.SwitchBetweenSphereAndMiniSphere(
          this.store.selectSnapshot(ServiceState.getServiceSelectedId),
          this.store.selectSnapshot(PatientState.getSelectedPatient)?._id,
          modeSphere === this.sepherMode.MINI ? SphereModeEnum.COMPLETE : SphereModeEnum.MINI)));
  }
}
